class MervauxCollectionControls extends HTMLElement {
  connectedCallback() {
    this.browsePanel = this.querySelector('[data-mervaux-browse-panel]');
    this.refinementPanel = this.querySelector('[data-mervaux-refinement-panel]');
    if (!this.browsePanel || !this.refinementPanel) return;
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.syncPanels = () => {
      this.browsePanel.open = !this.mobileQuery.matches;
      this.refinementPanel.open = this.mobileQuery.matches;
    };
    this.syncPanels();
    this.mobileQuery.addEventListener('change', this.syncPanels);
  }

  disconnectedCallback() {
    this.mobileQuery?.removeEventListener('change', this.syncPanels);
  }
}

if (!customElements.get('mervaux-collection-controls')) {
  customElements.define('mervaux-collection-controls', MervauxCollectionControls);
}
